import { useState } from "react";
import { Calculator as CalcIcon } from "lucide-react";
import { Calculator } from "@/components/Calculator";
import { useSeo } from "@/lib/seo";

const CALCS = [
  { type: "reee", title: "REEE — Études des enfants", tag: "Croissance" },
  { type: "celi", title: "CELI — Épargne libre d'impôt", tag: "Croissance" },
  { type: "celiapp", title: "CELIAPP — Première propriété", tag: "Croissance" },
  { type: "reer", title: "REER — Retraite", tag: "Croissance" },
  { type: "fondsdistincts", title: "Fonds distincts", tag: "Croissance" },
  { type: "vie", title: "Assurance vie — Besoins", tag: "Protection" },
  { type: "invalidite", title: "Invalidité — Écart de revenu", tag: "Protection" },
  { type: "maladiesgraves", title: "Maladies graves", tag: "Protection" },
  { type: "sld", title: "Soins de longue durée", tag: "Protection" },
  { type: "rentes", title: "Rentes viagères", tag: "Revenu" },
  { type: "fiscalite", title: "Impôt — Revenu net", tag: "Fiscalité" },
];

export default function Calculatrices() {
  const [sel, setSel] = useState(CALCS[0]);
  useSeo("Calculatrices — Mon Projet Protégé", "Accès direct à toutes les calculatrices financières : REEE, CELI, CELIAPP, REER, fonds distincts, assurances et plus.");

  return (
    <div data-testid="calculatrices-page" className="max-w-5xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
      <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#C89A3E]"><CalcIcon size={15} /> Outils</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-bold text-[#012141] font-heading leading-tight">Calculatrices</h1>
      <p className="mt-2 text-base text-slate-500 max-w-2xl">Estimez en quelques secondes la croissance de votre épargne (REEE, CELI, CELIAPP, REER, fonds distincts) et vos besoins de protection. Ajustez les montants, le rendement et les frais pour visualiser leur impact.</p>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-4">
          <div className="flex flex-wrap lg:flex-col gap-2">
            {CALCS.map((c) => (
              <button key={c.type} data-testid={`calc-tab-${c.type}`} onClick={() => setSel(c)}
                className={`text-left px-4 py-3 rounded-2xl border text-sm font-semibold transition-all ${sel.type === c.type ? "bg-[#012141] text-white border-[#012141]" : "bg-white text-[#012141] border-[#012141]/12 hover:border-[#C89A3E]"}`}>
                <div className="flex items-center justify-between gap-2">
                  <span>{c.title}</span>
                  <span className={`text-[10px] font-bold uppercase tracking-wide ${sel.type === c.type ? "text-[#F5C64E]" : "text-[#C89A3E]"}`}>{c.tag}</span>
                </div>
              </button>
            ))}
          </div>
        </aside>
        <div className="lg:col-span-8">
          <Calculator key={sel.type} type={sel.type} />
        </div>
      </div>
    </div>
  );
}
